'use client';

import * as React from 'react';

import { Button } from '../button';
import { HStack } from '../stack';

export interface FormActionsProps {
  onCancel: () => void;
  formId?: string;
  isSubmitting?: boolean;
  submitLabel?: string;
  cancelLabel?: string;
  submitColorPalette?: string;
  extraActions?: React.ReactNode;
  disabled?: boolean;
}

export function FormActions({
  onCancel,
  formId,
  isSubmitting = false,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  submitColorPalette = 'blue',
  extraActions,
  disabled = false,
}: FormActionsProps) {
  return (
    <HStack gap={3} justify="flex-end" width="100%">
      {extraActions}
      <Button variant="ghost" onClick={onCancel} disabled={isSubmitting}>
        {cancelLabel}
      </Button>
      <Button
        type="submit"
        form={formId}
        colorPalette={submitColorPalette}
        isLoading={isSubmitting}
        disabled={disabled}
      >
        {submitLabel}
      </Button>
    </HStack>
  );
}

FormActions.displayName = 'FormActions';
